module.exports = __webpack_public_path__ + "static/media/task-name.2a8a719a.png";